import { type KycAnswersFields } from '@resurs-internal/deposits-app-components';

import { type KycAnswers, type KycAnswersForGroup } from '@/models';
import { type ApplicationDetailsResponseDTO } from '@/types/consumer-deposit-application-service';

import { type InitialApplication } from './useApplication';

export const kycAnswers = ({
  application,
  save,
}: InitialApplication): KycAnswersFields => {
  const initialKycAnswers = (application.kycAnswers || {}) as KycAnswers;

  const initialAnswersForGroup = (groupName: string) => {
    if (Object.keys(initialKycAnswers).includes(groupName)) {
      const matchingGroups = Object.entries(initialKycAnswers)
        .filter((answer) => answer[0] == groupName)
        .map((answer) => answer[1]);

      return matchingGroups[0];
    }

    return {};
  };

  const saveAnswersForGroup = async (
    groupName: string,
    answersForGroup: KycAnswersForGroup,
  ) => {
    const currentAnswers = (application.kycAnswers || {}) as KycAnswers;

    return save({
      kycAnswers: {
        ...currentAnswers,
        [groupName]: {
          ...currentAnswers[groupName],
          ...answersForGroup,
        },
      } as ApplicationDetailsResponseDTO['kycAnswers'],
    });
  };

  return {
    initialAnswersForGroup,
    saveAnswersForGroup,
  };
};
